import { HttpRequest } from '@angular/common/http';
import { InjectionToken } from '@angular/core';

export const exceptURL: string[] = [];

export const AUTH_TOKEN_INTERCEPTOR_FILTER = new InjectionToken<
    (req: HttpRequest<any>) => boolean
>('Interceptor Filter');
